if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.Products = (function () {
  const config = {
    howManyToShow: 4,
    howManyToStoreInMemory: 10,
    wrapperId: 'recently-viewed-products',
    templateId: 'recently-viewed-product-template',
    onComplete: null,
  };

  let handles = [];
  let wrapper = null;
  let template = null;
  let productsRendered = 0;

  const cookie = {
    configuration: { expires: 90, path: '/', domain: window.location.hostname },
    name: 'shopify_recently_viewed',

    write: function (handles) {
      const expires = new Date();
      expires.setTime(expires.getTime() + this.configuration.expires * 24 * 60 * 60 * 1000);
      document.cookie = `${this.name}=${handles.join(' ')};expires=${expires.toUTCString()};path=${
        this.configuration.path
      };domain=${this.configuration.domain}`;
    },

    read: function () {
      const nameEQ = this.name + '=';
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        let c = cookies[i].trim();
        if (c.indexOf(nameEQ) === 0) {
          return c.substring(nameEQ.length).split(' ');
        }
      }
      return [];
    },

    destroy: function () {
      document.cookie = `${this.name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=${this.configuration.path};domain=${this.configuration.domain}`;
    },

    remove: function (handle) {
      const handles = this.read();
      const index = handles.indexOf(handle);
      if (index !== -1) {
        handles.splice(index, 1);
        this.write(handles);
      }
    },
  };

  const complete = function () {
    wrapper.style.display = 'block';
    if (config.onComplete) {
      try {
        config.onComplete();
      } catch (e) {}
    }
  };

  const getMetafields = function (id) {
    return new Promise((resolve, reject) => {
      const myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');
      myHeaders.append('X-Shopify-Storefront-Access-Token', '65302ec703cac627b630bab92f5d9b54');

      const graphql = JSON.stringify({
        query:
          'query getProductMetafields($id: ID!) {\n  product(id: $id) {\n    title\n    id\n    handle\n    tags\n    onlineStoreUrl\n    priceRange{\n        minVariantPrice{\n            amount\n            currencyCode\n        }\n    }\n    images(first: 2){\n        edges{\n            node{\n                id\n                url\n            }\n        }\n    }\n    color: metafield(namespace: "rocket", key: "color") {\n      value\n    }\n    model: metafield(namespace: "rocket", key: "model") {\n      value\n    }\n    shortname: metafield(namespace: "rocket", key: "short_name") {\n      value\n    }\n    gender: metafield(namespace: "rocket", key: "gender") {\n      value\n    }\n  }\n}\n\n',
        variables: { id: 'gid://shopify/Product/' + id },
      });

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: graphql,
        redirect: 'follow',
      };

      fetch('https://balmohk.myshopify.com/api/2026-01/graphql.json', requestOptions)
        .then((response) => response.json())
        .then((result) => {
          let metafieldsObject = {};
          let product = result.data.product;
          metafieldsObject.shortName = product.shortname.value;
          metafieldsObject.model = product.model.value;
          metafieldsObject.color = product.color.value;
          metafieldsObject.gender = product.gender.value;
          resolve(metafieldsObject);
        })
        .catch((error) => {
          console.error('Error fetching metafields:', error);
          reject(error);
        });
    });
  };

  const renderProduct = function () {
    if (handles.length && productsRendered < config.howManyToShow) {
      fetch(`/products/${handles[1]}.js`)
        .then((response) => response.json())
        .then((product) => {
          const productID = product.id;
          const productHandle = product.handle;

          getMetafields(productID)
            .then((metafields) => {
              product.index = productsRendered + 1;
              product.shortname = metafields.shortName;
              product.model = metafields.model;
              product.color = metafields.color;
              product.gender = metafields.gender;

              if (product.tags.includes('NEW')) {
                product.badge = 'new';
              } else if (!product.available) {
                product.badge = 'sold';
              } else if (product.compare_at_price > product.price) {
                product.badge = 'sale';
              }

              const templateContent = template.innerHTML;
              const rendered = renderTemplate(templateContent, product);
              wrapper.insertAdjacentHTML('beforeend', rendered);

              handles.shift();
              productsRendered++;
              renderProduct();
            })
            .catch((error) => {
              console.error('Error:', error);
            });
        })
        .catch(() => {
          cookie.remove(handles[0]);
          handles.shift();
          renderProduct();
        });
    } else {
      complete();
    }
  };

  const renderTemplate = function (templateStr, data) {
    return templateStr.replace(/\${(\w+)}/g, (match, key) => {
      return data[key] !== undefined ? data[key] : '';
    });
  };

  return {
    resizeImage: function (src, size) {
      if (size == null) {
        return src;
      }
      if (size == 'master') {
        return src.replace(/http(s)?:/, '');
      }
      const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?/i);
      if (match != null) {
        const prefix = src.split(match[0]);
        const suffix = match[0];
        return (prefix[0] + '_' + size + suffix).replace(/http(s)?:/, '');
      } else {
        return null;
      }
    },

    showRecentlyViewed: function (options) {
      options = options || {};
      Object.assign(config, options);

      handles = cookie.read();
      template = document.getElementById(config.templateId);
      wrapper = document.getElementById(config.wrapperId);

      config.howManyToShow = Math.min(handles.length, config.howManyToShow);
      if (config.howManyToShow && template && wrapper) {
        renderProduct();
      }
    },

    getConfig: function () {
      return config;
    },

    clearList: function () {
      cookie.destroy();
    },

    recordRecentlyViewed: function (options) {
      options = options || {};
      Object.assign(config, options);

      let handles = cookie.read();
      if (window.location.pathname.indexOf('/products/') !== -1) {
        const handle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
        const index = handles.indexOf(handle);
        if (index === -1) {
          handles.unshift(handle);
          handles = handles.splice(0, config.howManyToStoreInMemory);
        } else {
          handles.splice(index, 1);
          handles.unshift(handle);
        }
        cookie.write(handles);
      }
    },
  };
})();

Shopify.money_format = '{{amount}} €';
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  const value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, ',');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const centsPart = parts[1] ? decimal + parts[1] : '';

    return dollars + centsPart;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      return formatWithDelimiters(cents, 2);
    case 'amount_no_decimals':
      return formatWithDelimiters(cents, 0);
    case 'amount_with_comma_separator':
      return formatWithDelimiters(cents, 2, '.', ',');
    case 'amount_no_decimals_with_comma_separator':
      return formatWithDelimiters(cents, 0, '.', ',');
  }

  return formatString.replace(placeholderRegex, value);
};
